<template>
  <div
    class="container-xl px-3 px-xl-0 d-flex flex-wrap align-items-center justify-content-between md-justify-content-center justify-content-lg-start">

    <!-- **** sidebar start **** -->
    <Sidebar class="header-sideBar-menu bg-gray-100" v-model:visible="visible"
      :position="(width >= breakpoints.screen_smallMobile && width <= breakpoints.screen_tablet) ? 'left' : 'full'">
      <!-- style="transform: translate3d(0px, 0px, 0px) !important; transition: transform 0.3s !important;" -->

      <!-- sidebar header -->
      <template #header>
        <nuxt-link to="/" aria-label="Retour à l'accueil TopAuto" @click="handleHomeClick">
          <img class="logo-black" src="~/assets/images/logos/top-auto-logo-black.svg" alt="Logo TopAuto" />
          <img class="logo-dark" src="~/assets/images/logos/LogoTA-Dark.svg" alt="Logo TopAuto" />
        </nuxt-link>
      </template>
      <!-- links -->
      <div class="nav bg-white">
        <li>
          <nuxt-link to="/voitures" class="btn ps-12 fsz-12" :aria-disabled="isOnVoitures" @click="handleVoituresClick"
            exact-active-class="bg-primary text-white">Acheter une voiture
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/vendre-voiture" class="btn ps-12 fsz-12" @click="closeSideBar"
            exact-active-class="bg-primary text-white">Vendre ma voiture</nuxt-link>
        </li>
        <li v-if="isAuthKnown && dashStore.getIsUserConnected">
          <nuxt-link to="/dashboard/saveditems" class="btn ps-12 fsz-12" @click="closeSideBar"
            exact-active-class="bg-primary text-white">Favoris</nuxt-link>
        </li>
      </div>
      <!-- actions -->
      <div>
        <nuxt-link
          class="btn xsmaller-btn btn-solid-primary-600 d-flex align-items-center justify-content-center ps-12 fsz-12 w-100 rounded-2"
          @click="handleAddAnnounce">
          <i class="material-symbols-rounded fsz-20 me-1">add</i>
          Ajouter une annonce
        </nuxt-link>

      </div>
    </Sidebar>

    <button class="iconBtn d-lg-none" style="padding: 6px !important" @click="visible = true">
      <i class="material-symbols-rounded fsz-24">reorder</i>
    </button>

    <!-- **** sidebar end  **** -->
    <nuxt-link to="/"
      class="me-lg-64 flex-grow-1 flex-lg-grow-0 d-flex justify-content-center justify-content-lg-start logo-container"
      aria-label="Retour à l'accueil TopAuto" @click="handleHomeClick">
      <img class="logo-white" src="~/assets/images/logos/top-auto-logo.svg" alt="Logo TopAuto" />
      <img class="logo-black" src="~/assets/images/logos/top-auto-logo-black.svg" alt="Logo TopAuto" />
      <img class="logo-dark" src="~/assets/images/logos/LogoTA-Dark.svg" alt="Logo TopAuto" />
    </nuxt-link>

    <ul
      class="nav col-12 col-lg-auto me-lg-auto mb-2 pt-md-1 d-flex justify-content-center justify-content-md-start justify-content-lg-center mb-md-0 gap-4 d-none d-lg-flex">
      <li>
        <nuxt-link to="/voitures" class="nav-link px-2" :aria-disabled="isOnVoitures"
          @click="handleVoituresClick">Acheter
          une voiture</nuxt-link>
      </li>
      <li>
        <nuxt-link to="/vendre-voiture" class="nav-link px-2">Vendre ma voiture</nuxt-link>
      </li>
      <li v-if="isAuthKnown && dashStore.getIsUserConnected">
        <nuxt-link to="/dashboard/saveditems" class="nav-link px-2 sauvagarde">Favoris</nuxt-link>
      </li>
    </ul>
    <div v-if="isAuthKnown" class="navbar-end">
      <div v-if="dashStore.getIsUserConnected">
        <div class="d-flex gap-1 gap-md-3 align-items-center justify-content-center">
          <div class="cursor-pointer d-none d-xl-block AddAnnounceLink">
            <nuxt-link class="btn xsmaller-btn d-none d-lg-flex align-items-center" to="/vendre-voiture">
              <i class="material-symbols-rounded fsz-20 me-1">add_2</i>
              Créer une annonce
            </nuxt-link>

          </div>
          <div class="me-2 AddAnnounceLink d-sm-none">
            <nuxt-link class="addBtnMob d-flex align-items-center justify-content-center rounded-circle"
              style="width: 32px; height: 32px" @click="handleAddAnnounce">
              <i class="material-symbols-rounded fsz-20">add_2</i>
            </nuxt-link>
          </div>

          <div
            class="tokens-container d-none d-sm-flex flex-row justify-content-center align-items-center border border-1 cursor-pointer rounded-3"
            @click="billingModal = true">
            <div class="d-flex flex-row justify-content-center align-items-center" style="width: 22px; height: 22px;">
              <img src="~/assets/images/logos/TopAuto_token_.svg" />
            </div>
            <span class="fsz-14 text-gray-900 lh-base d-flex flex-row gap-1"><b>{{ dashStore.getUserProfil.freeCredits +
              dashStore.getUserProfil.additionalCredits }}</b> Credits</span>

          </div>

          <div class="d-none d-sm-block">
            <PanelsNotification />

          </div>

          <UiElementAvatar />
        </div>
      </div>
      <div v-else class="d-flex align-items-center gap-3 AddAnnounceLink">
        <nuxt-link class="btn btn-solid-primary-600 d-none d-lg-inline-flex" to="/authentication/login">
          Connexion
        </nuxt-link>

        <nuxt-link class="btn xsmaller-btn d-none d-lg-inline-flex align-items-center" to="/vendre-voiture">
          <i class="material-symbols-rounded fsz-20 me-1">add_2</i>
          Ajouter une annonce
        </nuxt-link>
      </div>

    </div>
    <div v-else>
      <div class="navbar-end d-none d-lg-flex align-items-center gap-3" style="opacity: 0.1;">
        <Skeleton class="d-none d-xl-inline-block rounded-3" width="192px" height="40px" />
        <Skeleton class="d-inline-block rounded-3" width="162px" height="40px" />
        <Skeleton class="d-inline-block rounded-circle" width="20px" height="20px" />
        <Skeleton class="d-inline-block rounded-circle" width="32px" height="32px" />
      </div>
      <div class="navbar-end d-flex d-lg-none align-items-center gap-3" style="opacity: 0.1;">
        <Skeleton class="d-inline-block rounded-circle" width="32px" height="32px" />
        <Skeleton class="d-inline-block rounded-circle" width="32px" height="32px" />
      </div>
    </div>
    <!-- mobil navbar connection toggel -->
    <div v-if="isAuthKnown" class="navbar-user-container d-lg-none">
      <div v-if="!dashStore.getIsUserConnected" style="width: 24px; height: 24px;">
        <nuxt-link class="iconBtn" to="/authentication/login">
          <i class="material-symbols-rounded fsz-24">person_add</i>

        </nuxt-link>
      </div>


    </div>

  </div>
  <DialogsBilling :visible="billingModal" @update:visible="(e) => billingModal = e" />
</template>

<script lang="ts" setup>
import { trackAnnouncementStarted } from '~/composables/useFirebaseAnalytics'
import { useWindowSize } from "@vueuse/core";
import { breakpoints } from "../utils/breakpoints"
import Skeleton from "primevue/skeleton";
import {
  getDisplayedPromotedIds,
  getUniquePromotedAnnouncements,
} from "~/utils/promotedResults";

const dashStore = useDashboardStore();
// No authReady needed - init-auth.ts plugin handles authentication before components mount
const isAuthKnown = computed(() => true); // Always render auth UI, store state determines what shows
const windowSize = useWindowSize({
  initialWidth: breakpoints.screen_laptop + 1,
  initialHeight: 900
});
const isMounted = ref(false);
const width = computed(() =>
  (isMounted.value ? windowSize.width.value : breakpoints.screen_laptop + 1) ||
  breakpoints.screen_laptop + 1
);
const visible = ref(false);
const billingModal = ref(false);
const isVoituresRedirectLoading = ref(false);
const searchStore = useSearchStore();
const uiStore = useUiStateStore();
const route = useRoute();
const runTimeConfig = useRuntimeConfig();
const { sendAddAnnouncementTelegram } = useAddAnnouncementTelegram();
const BACK_SKIP_KEY = "topauto:skip-search-refetch-on-back";
const createEmptySearchResult = () => ({
  totalCount: 0,
  announcements: [],
  filters: {} as UserSearchInput,
});

const closeSideBar = () => {
  visible.value = false;
};

const resetSearchStateForHome = () => {
  closeSideBar();
  searchStore.resetStoreValues();
  searchStore.searchResult = createEmptySearchResult();
  searchStore.setAnnounceCount(0);
  Object.assign(uiStore.search, {
    sortBy: "",
    filterSidebarOpen: false,
    sortSidebarOpen: false,
  });

  if (process.client) {
    sessionStorage.removeItem(BACK_SKIP_KEY);
  }
};

const handleHomeClick = (event?: Event) => {
  resetSearchStateForHome();
  if (route.path !== "/") return;
  event?.preventDefault();
  reloadNuxtApp({ path: "/", force: true });
};

const isOnVoitures = computed(() => route.path.startsWith('/voitures'));
const buildPromotedPayload = () => {
  let payload: Record<string, any> = {};
  const selectedMakes = Array.isArray(searchStore.userInput?.makes)
    ? searchStore.userInput.makes
    : [];
  const selectedModels = Array.isArray(searchStore.userInput?.models)
    ? searchStore.userInput.models
    : [];

  const makesIds = selectedMakes
    .map((make: any) => make?.id)
    .filter((id: any) => typeof id === "number");
  const modelsIds = selectedModels
    .map((model: any) => model?.id)
    .filter((id: any) => typeof id === "number");

  if (makesIds.length) payload.makesIds = makesIds;
  if (modelsIds.length) payload.modelsIds = modelsIds;

  payload = {
    ...payload,
    ...searchStore.filterUserSearchInput(searchStore.userInput),
  };

  return Object.fromEntries(
    Object.entries(payload).filter(([key, value]) => key !== "front" && value !== false)
  );
};

const fetchPromotedForCurrentSearch = async (options?: {
  resetOldPromotedIds?: boolean;
}) => {
  const payload = buildPromotedPayload();
  const limit = Object.keys(payload).length > 0 ? 10 : 2;
  const oldPromotedAnnouncementIds = options?.resetOldPromotedIds
    ? []
    : getDisplayedPromotedIds(
      searchStore.getPromotedSearchResult ?? [],
      searchStore.getFetchResult?.announcements ?? []
    );

  const response: any = await $fetch("/announcements/promoted-search-result", {
    method: "POST",
    headers: {
      token: runTimeConfig.public.token,
    },
    body: { ...payload, limit, oldPromotedAnnouncementIds, },
    baseURL: runTimeConfig.public.baseUrl,
  });

  const announcements = Array.isArray(response)
    ? response
    : response?.announcements ?? [];

  searchStore.setPromotedSearchResult(
    getUniquePromotedAnnouncements(announcements)
  );
};

const handleVoituresClick = async (event: Event) => {
  if (isOnVoitures.value) {
    event.preventDefault();
    return;
  }

  event.preventDefault();
  if (isVoituresRedirectLoading.value) return;

  isVoituresRedirectLoading.value = true;
  closeSideBar();
  searchStore.resetStoreValues();

  try {
    await fetchPromotedForCurrentSearch({ resetOldPromotedIds: true });
    await searchStore.fetchAnnounce(1, dashStore.getUserProfil.id);
    if (typeof searchStore.getFetchResult?.totalCount === "number") {
      searchStore.setAnnounceCount(searchStore.getFetchResult.totalCount);
    }
    await navigateTo('/voitures');
  } catch (error) {
    console.error(error);
    await navigateTo('/voitures');
  } finally {
    isVoituresRedirectLoading.value = false;
  }
};

const handleAddAnnounce = () => {
  void sendAddAnnouncementTelegram('manuel')
  trackAnnouncementStarted({ announce_type_created: 'Manuel' })
  navigateTo('/listing-form/vehicle-data?fresh=true')
}

onMounted(() => {
  isMounted.value = true;
  // User auth is already handled by init-auth.ts plugin
});

</script>

<style lang="scss" scoped>
.AddAnnounceBtn:has(svg) svg {
  margin: 0;
  margin-right: 0;
}

.header-desktop-only {
  @media (max-width: 991px) {
    display: none !important;
  }
}
</style>
